if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType || "page";

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        const selectedPackCard = this.querySelector(
          "[data-pack-selector] .qty-pack-selector__radio:checked",
        )?.closest(".qty-pack-row");
        const selectedPackVariantId = selectedPackCard?.dataset.tierVariantId;
        const selectedPackQuantity = selectedPackCard?.dataset.tierQty;
        const selectedPackTotalPrice = selectedPackCard?.dataset.tierTotalPrice;

        if (selectedPackVariantId && this.formInput) {
          this.formInput.value = selectedPackVariantId;
        }

        const formData = new FormData(this.form);
        if (selectedPackVariantId) {
          formData.set("id", selectedPackVariantId);
        }
        if (selectedPackQuantity) {
          formData.set("quantity", selectedPackQuantity);
        }
        const sections =
          this.cart && typeof this.cart.getSectionsToRender === "function"
            ? this.cart.getSectionsToRender().map((section) => section.id)
            : [];
        const buildProductOnlyConfig = () => {
          const productOnlyConfig = fetchConfig("javascript");
          productOnlyConfig.headers["X-Requested-With"] = "XMLHttpRequest";
          delete productOnlyConfig.headers["Content-Type"];

          const productOnlyFormData = new FormData(this.form);
          if (selectedPackVariantId) {
            productOnlyFormData.set("id", selectedPackVariantId);
          }
          if (selectedPackQuantity) {
            productOnlyFormData.set("quantity", selectedPackQuantity);
          }
          productOnlyFormData.append("sections", sections);
          productOnlyFormData.append("sections_url", window.location.pathname);
          productOnlyConfig.body = productOnlyFormData;

          return productOnlyConfig;
        };
        const formQuantity = Number(formData.get("quantity") || 1);
        const selectedVariantPrice = Number(
          this.dataset.selectedVariantPrice || 0,
        );
        const estimatedLinePrice =
          selectedPackTotalPrice != null
            ? Number(selectedPackTotalPrice)
            : selectedVariantPrice * formQuantity;
        let bundledGiftWithAdd = false;
        let giftAddRequest = null;
        const replaceCheckoutCart = this.dataset.directCheckout === "true" &&
          this.dataset.clearCartBeforeCheckout === "true";
        if (replaceCheckoutCart) {
          try {
            const variantId = Number(formData.get("id"));
            if (!Number.isSafeInteger(variantId) || variantId <= 0 || ![1, 2, 3].includes(formQuantity)) {
              throw new Error("Selecciona un pack válido antes de continuar.");
            }
            const clearResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart/clear.js`, {
              method: "POST", headers: { Accept: "application/json" }
            });
            if (!clearResponse.ok) throw new Error("No se ha podido vaciar el carrito. Inténtalo de nuevo.");
            const clearedCart = await clearResponse.json();
            if (clearedCart.item_count !== 0) throw new Error("No se ha podido vaciar el carrito. Inténtalo de nuevo.");
            window.IniraCartGiftSync?.rememberCart?.(clearedCart);
          } catch (error) {
            this.handleErrorMessage(error.message);
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
            if (loader) loader.classList.add("hidden");
            return;
          }
        }
        // After a reset, reconcile gifts from the new cart, not the stale drawer.
        if (estimatedLinePrice > 0 && !replaceCheckoutCart) {
          try {
            giftAddRequest =
              (await window.IniraCartGiftSync?.prepareAddRequest?.({
                formData,
                sections,
                sectionsUrl: window.location.pathname,
                estimatedLinePrice,
              })) || null;
          } catch (error) {
            console.error(error);
            giftAddRequest = null;
          }
        }

        if (giftAddRequest) {
          config.body = giftAddRequest.body;
          bundledGiftWithAdd = true;
        } else {
          delete config.headers["Content-Type"];
          formData.append("sections", sections);
          formData.append("sections_url", window.location.pathname);
          config.body = formData;
        }

        let retriedProductOnly = false;
        const fetchCartAdd = (requestConfig) =>
          fetch(`${routes.cart_add_url}`, requestConfig).then((response) =>
            response.json(),
          );
        const retryProductOnlyAdd = (error) => {
          if (error) console.error(error);
          bundledGiftWithAdd = false;
          retriedProductOnly = true;
          return fetchCartAdd(buildProductOnlyConfig());
        };

        fetchCartAdd(config)
          .catch((error) => {
            if (bundledGiftWithAdd) {
              return retryProductOnlyAdd(error);
            }

            throw error;
          })
          .then(async (response) => {
            if (response.status && bundledGiftWithAdd) {
              response = await retryProductOnlyAdd();
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");

              this.dispatchEvent(
                new CustomEvent("cart-drawer:refresh", {
                  detail: { response: response },
                  bubbles: true,
                  composed: true,
                }),
              );

              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (this.dataset.directCheckout === "true") {
              if (retriedProductOnly || !bundledGiftWithAdd) {
                await window.IniraCartGiftSync?.sync();
              }
              const shopRoot = window.Shopify?.routes?.root || "/";
              const checkoutDiscount = this.dataset.checkoutDiscount || "QUIZ10";
              window.location.assign(replaceCheckoutCart
                ? `${shopRoot}discount/${encodeURIComponent(checkoutDiscount)}?redirect=${encodeURIComponent(`${shopRoot}checkout`)}`
                : `${shopRoot}checkout`);
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            if (retriedProductOnly || (!bundledGiftWithAdd && estimatedLinePrice <= 0)) {
              window.IniraCartGiftSync?.sync();
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on",
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            if (replaceCheckoutCart) {
              this.error = true;
              this.handleErrorMessage(e.message || "No se ha podido preparar la compra. Inténtalo de nuevo.");
            }
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            if (this.error) {
              this.disableLoadingInButton();
              return;
            }
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
              this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader",
            );

            if (!this.quick_add_container.classList.contains("hidden")) {
              // use handle and quickbuy closeCart()

              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }

            // delay button loading
            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200);
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
